<template>
  <v-snackbar v-model="show" :color="type">
    {{ message }}
    <v-btn text @click.native="show = false">Close</v-btn>
  </v-snackbar>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'Snackbar',
        data() {
            return {
                show: false,
                message: '',
                type: ''
            }
        },
        computed: {
            ...mapGetters({
                snack: 'snackbar/message',
                color: 'snackbar/color'
            })
        },
        watch: {
            snack(message) {
                if (!this.show && message) {
                    this.message = message
                    this.type = this.color
                    this.show = true
                }
            },
            show(value) {
                if (!value) {
                    this.message = ''
                    this.$store.dispatch('snackbar/reset')
                }
            }
        },
        created() {
        }
    }
</script>